import { Box } from '@mui/material';
import React from 'react';
import { Logo } from '../brand/Logo';
import { LinearProgressLoader } from './LinearProgressLoader';
import { LoaderMessage } from './Loader';
import './splash.css';

export function SplashLoader(props: { message?: React.ReactNode; showLoader?: boolean }) {
  const { message, showLoader = true } = props;

  return (
    <Box
      className="mi-ui-splash-loader-wrapper"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Logo className="mi-ui-splash-loader-logo" />
      {message && <LoaderMessage className="text-center">{message}</LoaderMessage>}
      {showLoader && (
        <Box sx={{ width: '250px', mt: 2 }}>
          <LinearProgressLoader />
        </Box>
      )}
    </Box>
  );
}
